import { useResponsive } from 'hooks/use-responsive';

import { GroupDrop } from '../group-drop';
import { SortDrop } from '../sort-drop';

import type { RivalGroupType } from 'api/api.types';
import type { DashboardSortType } from 'api/endpoints/rivals.types';

type FilterDropsProps = {
  rivalGroups: RivalGroupType[];
  group: number | undefined;
  onSelectGroup: (group: number | undefined) => void;
  sort: DashboardSortType;
  onSelectSort: (sort: DashboardSortType) => void;
};

const FilterDrops = ({
  rivalGroups,
  group,
  onSelectGroup,
  sort,
  onSelectSort,
}: FilterDropsProps) => {
  const { maxWidth } = useResponsive();
  return (
    <>
      <GroupDrop
        onSelectGroup={onSelectGroup}
        rivalGroups={rivalGroups}
        group={group}
        iconOnly={maxWidth.large}
      />
      <SortDrop
        onSelectSort={onSelectSort}
        sort={sort}
        iconOnly={maxWidth.large}
      />
    </>
  );
};

export default FilterDrops;
